import { UsdzManager } from "./Crystal.usdz";
import { GlbManager } from "./Crystal.glb";

// careful: github uses linux which is case-sensitive for paths; mac is case-insensitive
const crystal = new URL("../public/crystal.3b.usdz", import.meta.url).href;
const crystal2 = new URL("../public/crystal.3b.glb", import.meta.url).href;

export class B3 {
    private usdzManager = new UsdzManager();
    private glbManager = new GlbManager();

    private USDZ_MIME_TYPE = "model/vnd.usdz+zip";
    private GLB_MIME_TYPE = "model/model/gltf-binary";

    // USDZ: ios

    async mint(
        data: string, // silver, cover art, ar
        diamonds: File[] = [],
        color: string | number = "silver"
    ): Promise<Blob> {
        const blob = new Blob([data], { type: "text/plain" });
        const B = new File([blob], "B.txt", { type: "text/plain" });

        await this.usdzManager.loadFromUrl(crystal);
        return this.usdzManager.addFilesAndRezip([B, ...diamonds]);
    }

    async mine(crystal: File): Promise<{ data: string; diamonds: File[] }> {
        await this.usdzManager.loadFromFile(crystal);
        const files = await this.usdzManager.getFilesFrom3BFolder();

        let data = "";
        const diamonds: File[] = [];

        for (const file of files) {
            if (file.name === "B.txt") {
                data = await file.text();
            } else {
                diamonds.push(file);
            }
        }

        return { data, diamonds };
    }

    // GLB: android

    async mint2(
        data: string,
        diamonds: File[] = [],
        color: string | number = "silver"
    ): Promise<Blob> {
        await this.glbManager.importGLB(crystal2);
        return this.glbManager.addDataAndExport(data, diamonds);
    }

    async mine2(crystal: File): Promise<{ data: string; diamonds: File[] }> {
        await this.glbManager.importGLB(crystal);
        return this.glbManager.readUserData();
    }

    // helpers

    // not possible bc can't access file system
    async mineClipboard(): Promise<{
        data: string;
        diamonds: File[];
    } | null> {
        // 1. Check for browser support
        if (!navigator.clipboard?.read) {
            // throw new Error(
            //     "Clipboard API or the 'read' method is not supported in this browser."
            // );
            console.error(
                "Clipboard API or the 'read' method is not supported in this browser."
            );
            return null;
        }

        try {
            // 2. Request clipboard contents. This may trigger a permission prompt.
            const clipboardItems = await navigator.clipboard.read();

            // 3. Iterate through clipboard items to find one with the USDZ MIME type
            for (const item of clipboardItems) {
                if (item.types.includes(this.USDZ_MIME_TYPE)) {
                    // 4. Get the file data as a Blob
                    const blob = await item.getType(this.USDZ_MIME_TYPE);

                    // 5. Create and return a File object.
                    // Note: The original filename is not available when copying a file directly,
                    // so we must provide a default name.
                    const usdzFile = new File([blob], "Crystal.3B.usdz", {
                        type: this.USDZ_MIME_TYPE
                    });

                    console.log(
                        "Successfully retrieved USDZ file from clipboard:",
                        usdzFile
                    );
                    return this.mine(usdzFile);
                } else if (item.types.includes(this.GLB_MIME_TYPE)) {
                    // 4. Get the file data as a Blob
                    const blob = await item.getType(this.GLB_MIME_TYPE);

                    // 5. Create and return a File object.
                    // Note: The original filename is not available when copying a file directly,
                    // so we must provide a default name.
                    const usdzFile = new File([blob], "Crystal.3B.glb", {
                        type: this.GLB_MIME_TYPE
                    });

                    console.log(
                        "Successfully retrieved USDZ file from clipboard:",
                        usdzFile
                    );
                    return this.mine2(usdzFile);
                }
            }

            // If the loop completes, no USDZ file was found
            console.log("No USDZ file found on the clipboard.");
            return null;
        } catch (error: any) {
            // Handle potential errors, such as the user denying clipboard access
            //throw new Error("Failed to read from clipboard: " + error.message);
            console.error("Failed to read from clipboard: ", error.message);
            return null;
        }
    }
}
